import PageTransition from '@/components/page-transition/PageTransition';
import classes from './contact.module.scss';
import Text from '@/components/text/text';
import Hero from '@/components/hero/hero';
import Button from '@/components/button/button';
import SplitContent from '@/components/split_content/split_content';
import ContentArea from '@/components/content-area/content-area';
import StructuredData from './structured-data';
import Link from 'next/link';


export default function Contact() {

  return (
    <>
      <StructuredData />
      <PageTransition>
        <main className={classes.wrapper}>
          <div className={'body-bg'}></div>
          <Hero 
            title='Get in touch' 
          />

        <ContentArea hero>
          <>
          <SplitContent>
            <>
            <Text size='small' type={'h5'} column={1} >Reach out to our dedicated team today.</Text>
            <Text type={'p'} column={1} >Whether you have questions about <Link scroll={false} href="/services">our services</Link>, want to discuss a project, or simply want to learn more about how we can help your business thrive in the digital space, we&rsquo;re  here to assist you.</Text>
            </>
          </SplitContent>
          <Button target="_blank" column={3} style="primary" title="book a meeting" link={'https://calendly.com/eighteen-yards?primary_color=6930c3'} />
          <Button column={3} style="primary" title="Email Us" link={'mailto:benji@eighteenyards.com?subject=Enquiry through eighteenyards.com'} />
          </>
        </ContentArea>
          
        </main>
      </PageTransition>
    </>
  )
}
